
export const SELECT_ANSWER = 'SELECT_ANSWER'


// WEBPACK FOOTER //
// ./js/components/actionTypes.js